import { shape, string } from 'prop-types';

export const GENERAL_VIDEO_MODAL_NAME = 'general-video-modal';

export const VIDEO_PROP_TYPES = {
    video: shape({
        id: string,
        name: string,
        src: string
    }),
    sourceInfo: shape({
        videoName: string,
        mixpanel: shape({
            pageName: string
        }),
        bigQuery: shape({
            pageName: string
        })
    })
};
